import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { FaFileExcel } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import styles from "../Management.module.css"; // Importing CSS module
import UserRegions from "./UserRegions"; // Import the new component
import TestList from "./TestList"; // Import the new component
import PriceList from "./PriceList"; // Import the new component
import DoctorPerformanceDashboard from "./DoctorPerformanceDashboard"; // Import the new component
import RegionalMappings from "./RegionalMappings"; // Import the new component
import EmailMappings from "./EmailMappings"; // Import the email mappings component
import Phlebotomists from "./Phlebotomists"; // Phlebotomist admin CRUD
import BulkUploadModal from "../component/BulkUploadModal"; // Excel bulk upload
import { roleConfig } from "../config/roles"; // Import the role configuration
import {
  registerPasskey,
  isPasskeySupported,
  getAuthenticationOptions,
} from "../utilities/passkeyAuth"; // Import passkey auth functions

const Management = () => {
  const [cities, setCities] = useState([]);
  const [newCity, setNewCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCityModal, setShowModal] = useState(false);

  const [hospitals, sethospitals] = useState([]);
  const [newHospital, setNewHospital] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [newHospitalAddress, setNewHospitalAddress] = useState("");
  const [newHospitalPincode, setNewHospitalPincode] = useState("");
  const [hospitalQuery, setHospitalQuery] = useState("");
  const [cityQuery, setCityQuery] = useState("");

  const [SelectedCityForDoctor, setSelectedCityForDoctor] = useState("");
  const [showHospitalModal, setShowHospitalModal] = useState(false);
  const [selectedCityhospitals, setselectedCityhospitals] = useState([]);
  const [SelectedHospitalforDoctor, setSelectedHospitalforDoctor] = useState("");
  const [SelectedHospitalDoctorsList, setSelectedHospitalDoctorsList] = useState([]);
  const [showDoctorModal, setShowDoctorModal] = useState(false);
  const [newDoctor, setnewDoctor] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");

  // Edit City modal state
  const [editingCity, setEditingCity] = useState(null);
  const [editCityName, setEditCityName] = useState("");
  const [showEditCityModal, setShowEditCityModal] = useState(false);

  // Edit Hospital modal state
  const [editingHospital, setEditingHospital] = useState(null);
  const [editHospitalName, setEditHospitalName] = useState("");
  const [editHospitalCity, setEditHospitalCity] = useState("");
  const [editHospitalAddress, setEditHospitalAddress] = useState("");
  const [editHospitalPincode, setEditHospitalPincode] = useState("");
  const [showEditHospitalModal, setShowEditHospitalModal] = useState(false);

  // Edit Doctor modal state
  const [editOpen, setEditOpen] = useState(false);
  const [editingDoctor, setEditingDoctor] = useState(null);
  const [editName, setEditName] = useState("");
  const [editMobile, setEditMobile] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editHospitalId, setEditHospitalId] = useState("");

  // Tabs + All Doctors list
  const [activeDocTab, setActiveDocTab] = useState("byLocation"); // "byLocation" | "all"
  const [allDoctors, setAllDoctors] = useState([]);
  const [allDocLoading, setAllDocLoading] = useState(false);
  const [allDocError, setAllDocError] = useState("");
  const [allDocQuery, setAllDocQuery] = useState("");
  const [showDoctorBulkUpload, setShowDoctorBulkUpload] = useState(false);
  const [showHospitalBulkUpload, setShowHospitalBulkUpload] = useState(false);

  // Passkey management state
  const [passkeyLoading, setPasskeyLoading] = useState(false);
  const [passkeyRegistered, setPasskeyRegistered] = useState(false);

  // Sales Access Config state (per-user)
  const [salesAccessUsers, setSalesAccessUsers] = useState([]);   // [{ username, name, salesDataFromDate }]
  const [salesAccessDates, setSalesAccessDates] = useState({});   // { username: "YYYY-MM-DD" }
  const [salesAccessSaving, setSalesAccessSaving] = useState({});  // { username: bool }
  const [salesAccessLoaded, setSalesAccessLoaded] = useState(false);
  const [emailAutomationSettings, setEmailAutomationSettings] = useState({
    enabled: false,
    startDate: "",
    sendTime: "18:00",
    timezone: "Asia/Kolkata",
  });
  const [emailAutomationLoaded, setEmailAutomationLoaded] = useState(false);
  const [emailAutomationSaving, setEmailAutomationSaving] = useState(false);
  
  const userRole = localStorage.getItem('role');
  const username = localStorage.getItem('username');

  const allTabs = {
      city: "City",
      hospital: "Hospital",
      doctors: "Doctors",
      phlebotomists: "Phlebotomists",
      users: "Users",
      tests: "Tests",
      pricing: "Pricing",
      performance: "Doctor Performance",
      mappings: "Regional Mappings",
      emailMappings: "Email Mappings",
      passkey: "Security - Passkey",
      salesAccess: "Sales Access Config",
      emailAutomation: "Report Email Automation"
  };

  const accessibleTabs = Object.keys(allTabs).filter(tabKey => 
      roleConfig.management_tabs[tabKey] && roleConfig.management_tabs[tabKey].includes(userRole)
  );

  const [activeTab, setActiveTab] = useState(accessibleTabs[0] || "");

  // Fetch all doctors when switching to "All" tab
  useEffect(() => {
    const fetchAllDoctors = async () => {
      setAllDocLoading(true);
      setAllDocError("");
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/doctors`);
        setAllDoctors(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error("Error fetching all doctors:", e);
        setAllDocError("Failed to load doctors.");
        toast.error("Failed to load doctors.");
      } finally {
        setAllDocLoading(false);
      }
    };

    if (activeDocTab === "all" && allDoctors.length === 0 && !allDocLoading) {
      fetchAllDoctors();
    }
  }, [activeDocTab]); // eslint-disable-line

  // Fetch cities
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/cities`)
      .then((response) => setCities(response.data))
      .catch((error) => {
        console.error("Error fetching cities:", error);
        toast.error("Failed to load cities.");
      });
  }, []);

  // Fetch hospitals
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/hospitals`)
      .then((response) => sethospitals(response.data))
      .catch((error) => {
        console.error("Error fetching hospitals:", error);
        toast.error("Failed to load hospitals.");
      });
  }, []);

  // Fetch hospitals based on city for Doctors section
  useEffect(() => {
    const fetchHospitals = async () => {
      if (!SelectedCityForDoctor) {
        setselectedCityhospitals([]);
        return;
      }
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/hospitals/${SelectedCityForDoctor}`
        );
        setselectedCityhospitals(response.data);
      } catch (error) {
        console.error("Failed to fetch hospitals:", error);
        toast.error("Failed to fetch hospitals");
        setselectedCityhospitals([]);
      }
    };
    fetchHospitals();
  }, [SelectedCityForDoctor]);

  // Fetch doctors based on hospital
  useEffect(() => {
    const fetchDoctor = async () => {
      if (!SelectedHospitalforDoctor) {
        setSelectedHospitalDoctorsList([]);
        return;
      }
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/doctors/${SelectedHospitalforDoctor}`
        );
        setSelectedHospitalDoctorsList(response.data);
      } catch (error) {
        console.error("Failed to fetch Doctorlist:", error);
        toast.error("Failed to fetch Doctorlist");
        setSelectedHospitalDoctorsList([]);
      }
    };
    fetchDoctor();
  }, [SelectedHospitalforDoctor]);

  // Open Edit modal with row
  const openEditDoctor = (doc) => {
    setEditingDoctor(doc);
    setEditName(doc.doctorName || "");
    setEditMobile(doc.mobile_number || "");
    setEditEmail(doc.email || "");
    setEditHospitalId(String(doc.hospital_id || ""));
    setEditOpen(true);
  };

  // Save edited doctor
  const saveDoctorEdit = async () => {
    if (!editingDoctor) return;
    try {
      const payload = {
        doctorName: editName.trim(),
        mobile_number: editMobile.trim(),
        email: editEmail.trim(),
        // hospital_id: editHospitalId ? Number(editHospitalId) : undefined,
      };

      const res = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/doctors/${editingDoctor.id}`,
        payload
      );

      toast.success("Doctor updated");

      setAllDoctors((prev) =>
        prev.map((d) => (d.id === editingDoctor.id ? { ...d, ...res.data.data } : d))
      );

      setSelectedHospitalDoctorsList((prev) =>
        prev.map((d) => (d.id === editingDoctor.id ? { ...d, ...res.data.data } : d))
      );

      setEditOpen(false);
      setEditingDoctor(null);
    } catch (e) {
      console.error("Update doctor failed:", e);
      toast.error(e.response?.data?.error || "Failed to update doctor");
    }
  };

  // Edit city
  const openEditCity = (city) => {
    setEditingCity(city);
    setEditCityName(city.name);
    setShowEditCityModal(true);
  };
  const handleEditCity = () => {
    if (!editCityName.trim()) return toast.warn("City name cannot be empty.");
    setLoading(true);
    const token = localStorage.getItem("token");
    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/api/cities/${editingCity.id}`, { name: editCityName.trim() }, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        setCities((prev) => prev.map((c) => (c.id === editingCity.id ? { ...c, name: editCityName.trim() } : c)));
        setShowEditCityModal(false);
        setEditingCity(null);
        toast.success("City updated successfully!");
      })
      .catch((err) => toast.error(err.response?.data?.message || "Failed to update city."))
      .finally(() => setLoading(false));
  };
  const handleDeleteCity = (city) => {
    if (!window.confirm(`Delete city "${city.name}"? This cannot be undone.`)) return;
    const token = localStorage.getItem("token");
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/cities/${city.id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        setCities((prev) => prev.filter((c) => c.id !== city.id));
        toast.success("City deleted.");
      })
      .catch((err) => toast.error(err.response?.data?.message || "Failed to delete city."));
  };

  // Edit hospital
  const openEditHospital = (hospital) => {
    setEditingHospital(hospital);
    setEditHospitalName(hospital.hospitalName);
    setEditHospitalCity(String(hospital.city_id || ""));
    setEditHospitalAddress(hospital.hospitalAddress || "");
    setEditHospitalPincode(hospital.hospitalPincode || "");
    setShowEditHospitalModal(true);
  };

  const closeEditHospitalModal = () => {
    setShowEditHospitalModal(false);
    setEditingHospital(null);
    setEditHospitalName("");
    setEditHospitalCity("");
    setEditHospitalAddress("");
    setEditHospitalPincode("");
  };
  const handleEditHospital = () => {
    if (!editHospitalName.trim()) return toast.warn("Hospital name cannot be empty.");
    setLoading(true);
    const token = localStorage.getItem("token");
    
    const linkedCity = cities.find((c) => String(c.id) === String(editHospitalCity));
    const payload = {
      hospitalName: editHospitalName.trim(),
      city_id: editHospitalCity,
      hospitalAddress: editHospitalAddress.trim() || null,
      hospitalPincode: editHospitalPincode.trim() || null,
      hospitalCity: linkedCity ? linkedCity.name : null,
    };

    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/api/hospitals/${editingHospital.id}`, payload, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        sethospitals((prev) =>
          prev.map((h) =>
            h.id === editingHospital.id ? { ...h, ...payload } : h
          )
        );
        closeEditHospitalModal();
        toast.success("Hospital updated successfully!");
      })
      .catch((err) => toast.error(err.response?.data?.message || "Failed to update hospital."))
      .finally(() => setLoading(false));
  };
  const handleDeleteHospital = (hospital) => {
    if (!window.confirm(`Delete hospital "${hospital.hospitalName}"?`)) return;
    const token = localStorage.getItem("token");
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/hospitals/${hospital.id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        sethospitals((prev) => prev.filter((h) => h.id !== hospital.id));
        toast.success("Hospital deleted.");
      })
      .catch((err) => toast.error(err.response?.data?.message || "Failed to delete hospital."));
  };

  // Export the (filtered) city list to Excel
  const handleExportCities = (rows) => {
    if (!rows || rows.length === 0) {
      toast.warn("No cities to export.");
      return;
    }
    const data = rows.map((c) => ({ ID: c.id, "City Name": c.name }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Cities");
    XLSX.writeFile(wb, "Cities.xlsx");
  };

  // Export the (filtered) hospital list to Excel
  const handleExportHospitals = (rows) => {
    if (!rows || rows.length === 0) {
      toast.warn("No hospitals to export.");
      return;
    }
    const data = rows.map((h) => {
      const linkedCity = cities.find((c) => String(c.id) === String(h.city_id));
      return {
        ID: h.id,
        "Hospital Name": h.hospitalName || "",
        City: h.hospitalCity || (linkedCity ? linkedCity.name : ""),
        Address: h.hospitalAddress || "",
        Pincode: h.hospitalPincode || "",
      };
    });
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Hospitals");
    XLSX.writeFile(wb, "Hospitals.xlsx");
  };

  // Export the (filtered) doctor list to Excel
  const handleExportDoctors = () => {
    const hospitalById = new Map(hospitals.map((h) => [String(h.id), h]));
    const cityById = new Map(cities.map((c) => [String(c.id), c]));

    let list = allDoctors.map((d) => {
      const h = hospitalById.get(String(d.hospital_id));
      const c = h && h.city_id != null ? cityById.get(String(h.city_id)) : null;
      return { ...d, _hospitalName: h ? h.hospitalName : "", _cityName: c ? c.name : "" };
    });

    if (SelectedCityForDoctor) {
      list = list.filter((d) => {
        const h = hospitalById.get(String(d.hospital_id));
        return h && String(h.city_id) === String(SelectedCityForDoctor);
      });
    }
    if (SelectedHospitalforDoctor) {
      list = list.filter((d) => String(d.hospital_id) === String(SelectedHospitalforDoctor));
    }
    if (allDocQuery.trim()) {
      const q = allDocQuery.trim().toLowerCase();
      list = list.filter(
        (d) =>
          (d.doctorName || "").toLowerCase().includes(q) ||
          (d.mobile_number || "").toLowerCase().includes(q) ||
          (d.email || "").toLowerCase().includes(q) ||
          (d._hospitalName || "").toLowerCase().includes(q) ||
          (d._cityName || "").toLowerCase().includes(q)
      );
    }

    if (!list.length) {
      toast.warn("No doctors match the current filters.");
      return;
    }

    const data = list.map((d) => ({
      "Doctor Name": d.doctorName || "",
      Hospital: d._hospitalName || "",
      City: d._cityName || "",
      Mobile: d.mobile_number || "",
      Email: d.email || "",
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Doctors");
    XLSX.writeFile(wb, "Doctors.xlsx");
  };

  // Delete doctor
  const handleDeleteDoctor = (doctor) => {
    if (!window.confirm(`Delete doctor "${doctor.doctorName}"?`)) return;
    const token = localStorage.getItem("token");
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/doctors/${doctor.id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        setAllDoctors((prev) => prev.filter((d) => d.id !== doctor.id));
        setSelectedHospitalDoctorsList((prev) => prev.filter((d) => d.id !== doctor.id));
        toast.success("Doctor deleted.");
      })
      .catch((err) => toast.error(err.response?.data?.message || "Failed to delete doctor."));
  };

  // Add city
  const handleAddCity = () => {
    if (!newCity.trim()) return toast.warn("City name cannot be empty.");

    const cityExists = cities.find(
      (city) => city.name.toLowerCase() === newCity.trim().toLowerCase()
    );
    if (cityExists) {
      toast.warn(`Whoops! "${newCity.trim()}" is already here. No duplicates allowed!`);
      return;
    }

    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/cities`, { name: newCity.trim() })
      .then((response) => {
        setCities([...cities, response.data]);
        setNewCity("");
        setShowModal(false);
        toast.success("City added successfully!");
      })
      .catch((error) => {
        if (error.response?.status === 400) {
          toast.error(error.response.data.message || "City already exists!");
        } else {
          toast.error("Failed to add city. Please try again.");
        }
      })
      .finally(() => setLoading(false));
  };

  // Close the add-hospital modal and clear its fields
  const closeHospitalModal = () => {
    setShowHospitalModal(false);
    setNewHospital("");
    setSelectedCity("");
    setNewHospitalAddress("");
    setNewHospitalPincode("");
  };

  // Add hospital
  const handleAddHospital = () => {
    if (!selectedCity) return toast.warn("Please select a city.");
    if (!newHospital.trim()) return toast.warn("Hospital name cannot be empty.");

    const hospitalExists = hospitals.find(
      (h) => h.hospitalName.toLowerCase() === newHospital.trim().toLowerCase()
    );
    if (hospitalExists) {
      toast.warn(`Whoops! "${newHospital.trim()}" is already here. No duplicates allowed!`);
      return;
    }

    setLoading(true);
    const linkedCity = cities.find((c) => String(c.id) === String(selectedCity));
    const payload = {
      city_id: selectedCity,
      hospitalName: newHospital.trim(),
      hospitalAddress: newHospitalAddress.trim() || undefined,
      hospitalPincode: newHospitalPincode.trim() || undefined,
      hospitalCity: linkedCity ? linkedCity.name : undefined,
    };
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/hospitals`, payload)
      .then((response) => {
        sethospitals([...hospitals, response.data]);
        setNewHospital("");
        setSelectedCity("");
        setNewHospitalAddress("");
        setNewHospitalPincode("");
        setShowHospitalModal(false);
        toast.success("Hospital added successfully!");
      })
      .catch((error) => {
        toast.error(error.response?.data.message || "Failed to add hospital.");
      })
      .finally(() => setLoading(false));
  };

  // Bulk import hospitals from validated Excel rows
  const handleHospitalsBulkImport = async (rows) => {
    const cityByName = new Map(cities.map((c) => [String(c.name).trim().toLowerCase(), c]));

    const payload = rows
      .map((row) => {
        const city = cityByName.get(String(row["City"] ?? "").trim().toLowerCase());
        if (!city) return null;
        return {
          hospitalName: String(row["Hospital Name"] ?? "").trim(),
          city_id: city.id,
          hospitalAddress: String(row["Address"] ?? "").trim() || null,
          hospitalPincode: String(row["Pincode"] ?? "").trim() || null,
        };
      })
      .filter(Boolean);

    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/hospitals/bulk`,
        { hospitals: payload },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const { createdCount = 0, failed = [] } = res.data || {};
      if (createdCount > 0) toast.success(`${createdCount} hospital(s) imported successfully.`);
      if (failed.length > 0) {
        toast.error(
          `${failed.length} row(s) failed: ${failed
            .slice(0, 3)
            .map((f) => `${f.hospitalName || "Row " + (f.index + 1)} (${f.error})`)
            .join("; ")}${failed.length > 3 ? "…" : ""}`
        );
      }
      if (createdCount > 0) {
        const refreshed = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/hospitals`);
        sethospitals(Array.isArray(refreshed.data) ? refreshed.data : []);
      }
      setShowHospitalBulkUpload(false);
    } catch (error) {
      console.error("Failed to bulk import hospitals:", error);
      toast.error(error.response?.data?.error || "Failed to import hospitals.");
    }
  };

  // Add doctor
  const handleAddDoctor = () => {
    if (!newDoctor.trim()) return toast.warn("Doctor name cannot be empty.");
    if (!SelectedHospitalforDoctor)
      return toast.warn("Please select a hospital before adding a doctor.");

    if (!mobileNumber.trim()) {
      const ok = window.confirm("Mobile Number is not entered. Do you want to continue?");
      if (!ok) return;
    }
    if (!email.trim()) {
      toast.warn("Email Id is not entered");
      const ok = window.confirm("Email Id is not entered. Do you want to continue?");
      if (!ok) return;
    }

    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/doctors`, {
        doctorName: newDoctor.trim(),
        hospital_id: SelectedHospitalforDoctor,
        mobile_number: mobileNumber.trim(),
        email: email.trim(),
      })
      .then((response) => {
        toast.success(`Doctor "${response.data.doctorName}" added successfully!`);
        alert("Doctor added successfully!");
        setShowDoctorModal(false);
        setnewDoctor("");
        setMobileNumber("");
        setEmail("");
      })
      .catch((error) => {
        console.error("Failed to add doctor:", error);
        toast.error("Failed to add doctor. Please retry or contact support@zeinixlife.com");
        alert("Failed to add doctor. Please retry or contact support@zeinixlife.com");
      })
      .finally(() => setLoading(false));
  };

  // Bulk import doctors from validated Excel rows
  const handleDoctorsBulkImport = async (rows) => {
    const hospitalByName = new Map();
    hospitals.forEach((h) => {
      const key = `${String(h.hospitalName).trim().toLowerCase()}|${String(h.city_id)}`;
      hospitalByName.set(key, h);
    });
    const cityByName = new Map(cities.map((c) => [String(c.name).trim().toLowerCase(), c]));

    const payload = rows
      .map((row) => {
        const hospitalName = String(row["Hospital"] ?? "").trim().toLowerCase();
        const cityName = String(row["City"] ?? "").trim().toLowerCase();
        let hospital = null;
        if (cityName) {
          const city = cityByName.get(cityName);
          if (city) hospital = hospitalByName.get(`${hospitalName}|${city.id}`);
        } else {
          hospital = hospitals.find(
            (h) => String(h.hospitalName).trim().toLowerCase() === hospitalName
          );
        }
        if (!hospital) return null;
        return {
          doctorName: String(row["Doctor Name"] ?? "").trim(),
          hospital_id: hospital.id,
          mobile_number: String(row["Mobile Number"] ?? "").trim() || null,
          email: String(row["Email"] ?? "").trim() || null,
        };
      })
      .filter(Boolean);

    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/doctors/bulk`,
        { doctors: payload },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const { createdCount = 0, failed = [] } = res.data || {};
      if (createdCount > 0) toast.success(`${createdCount} doctor(s) imported successfully.`);
      if (failed.length > 0) {
        toast.error(
          `${failed.length} row(s) failed: ${failed
            .slice(0, 3)
            .map((f) => `${f.doctorName || "Row " + (f.index + 1)} (${f.error})`)
            .join("; ")}${failed.length > 3 ? "…" : ""}`
        );
      }
      if (createdCount > 0) {
        const refreshed = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/doctors`);
        setAllDoctors(Array.isArray(refreshed.data) ? refreshed.data : []);
      }
      setShowDoctorBulkUpload(false);
    } catch (error) {
      console.error("Failed to bulk import doctors:", error);
      toast.error(error.response?.data?.error || "Failed to import doctors.");
    }
  };

  const handlePasskeyRegister = async () => {
    if (!username) {
      toast.error("Unable to retrieve username. Please log in again.");
      return;
    }

    setPasskeyLoading(true);
    try {
      await registerPasskey(username);
      toast.success("Passkey registered successfully!");
      setPasskeyRegistered(true);
    } catch (error) {
      let errorMsg = "Failed to register passkey. Please try again.";
      if (error.message) {
        errorMsg = error.message;
      }
      toast.error(errorMsg);
    } finally {
      setPasskeyLoading(false);
    }
  };

  // Fetch sales access config (all users) on tab open
  useEffect(() => {
    if (activeTab === "salesAccess" && !salesAccessLoaded) {
      const token = localStorage.getItem("token");

      // Step 1: always load users from the existing endpoint
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/users/users-with-regions`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((usersRes) => {
          const allUsers = (Array.isArray(usersRes.data) ? usersRes.data : []).filter(
            (u) => !u.isDeactivated && u.Role === "sales_rep"
          );
          setSalesAccessUsers(allUsers);

          // Step 2: try to load saved dates — silently ignore if backend not ready yet
          axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/api/config/sales-access/all`, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((configRes) => {
              const dateMap = {};
              (Array.isArray(configRes.data) ? configRes.data : []).forEach((c) => {
                dateMap[c.Username || c.username] = c.salesDataFromDate || "";
              });
              setSalesAccessDates(dateMap);
            })
            .catch(() => {
              // Config endpoint not ready — that's OK, dates just start blank
            })
            .finally(() => setSalesAccessLoaded(true));
        })
        .catch(() => {
          toast.error("Failed to load sales persons");
          setSalesAccessLoaded(true);
        });
    }
  }, [activeTab]); // eslint-disable-line

  const handleSaveSalesAccessForUser = async (uname) => {
    setSalesAccessSaving((prev) => ({ ...prev, [uname]: true }));
    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/config/sales-access`,
        { username: uname, salesDataFromDate: salesAccessDates[uname] || null },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      toast.success(`Access date saved for ${uname}`);
    } catch (e) {
      toast.error(e.response?.data?.error || `Failed to save for ${uname}`);
    } finally {
      setSalesAccessSaving((prev) => ({ ...prev, [uname]: false }));
    }
  };

  useEffect(() => {
    if (activeTab !== "emailAutomation" || emailAutomationLoaded) return;

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/config/report-email-automation`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(({ data }) => {
        setEmailAutomationSettings({
          enabled: Boolean(data.enabled),
          startDate: data.startDate || "",
          sendTime: data.sendTime || "18:00",
          timezone: data.timezone || "Asia/Kolkata",
        });
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Failed to load report email automation settings.");
      })
      .finally(() => setEmailAutomationLoaded(true));
  }, [activeTab, emailAutomationLoaded]);

  const handleSaveEmailAutomationSettings = async () => {
    setEmailAutomationSaving(true);
    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/config/report-email-automation`,
        emailAutomationSettings,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setEmailAutomationSettings((current) => ({
        ...current,
        enabled: data.enabled,
        startDate: data.startDate,
        sendTime: data.sendTime,
        timezone: data.timezone,
      }));
      toast.success("Report email automation settings saved.");
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to save report email automation settings.");
    } finally {
      setEmailAutomationSaving(false);
    }
  };

  const checkPasskeyStatus = async () => {
    try {
      const opts = await getAuthenticationOptions(username);
      console.log("Check login-options returned:", opts);
      if (opts.allowCredentials && opts.allowCredentials.length) {
        toast.success("Passkey available on server.");
      } else {
        toast.info("No passkey found on server for this user.");
      }
    } catch (e) {
      toast.error("Error checking passkey: " + e.message);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "city": {
        const cq = cityQuery.trim().toLowerCase();
        const filteredCities = cities.filter(
          (c) => !cq || (c.name || "").toLowerCase().includes(cq)
        );
        return (
          <div className={styles.doctorsManagement}>
            <div className={styles.sectionTitle}>
              <h2>City Section</h2>
            </div>
            <div className={styles.toolbar}>
              <div className={styles.toolbarLeft}>
                <input
                  type="text"
                  className={styles.toolbarSearch}
                  placeholder="Search by city name"
                  value={cityQuery}
                  onChange={(e) => setCityQuery(e.target.value)}
                />
              </div>
              <div className={styles.toolbarRight}>
                <button className={styles.addCityBtn} onClick={() => setShowModal(true)}>
                  + Add New City
                </button>
                <button
                  className={styles.exportIconBtn}
                  title="Export to Excel"
                  aria-label="Export to Excel"
                  onClick={() => handleExportCities(filteredCities)}
                >
                  <FaFileExcel size={20} />
                </button>
              </div>
            </div>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>City Name</th>
                    <th style={{ textAlign: "right" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCities.map((city) => (
                    <tr key={city.id}>
                      <td>{city.id}</td>
                      <td>{city.name}</td>
                      <td style={{ textAlign: "right" }}>
                        <button className={styles.editBtn} onClick={() => openEditCity(city)} title="Edit" style={{ marginRight: 6 }}>✏️</button>
                        <button className={styles.editBtn} onClick={() => handleDeleteCity(city)} title="Delete" style={{ color: "crimson" }}>🗑️</button>
                      </td>
                    </tr>
                  ))}
                  {filteredCities.length === 0 && <tr><td colSpan={3} style={{ textAlign: "center", padding: 16 }}>No cities found.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        );
      }
      case "hospital": {
        const q = hospitalQuery.trim().toLowerCase();
        const filteredHospitals = hospitals.filter((h) => {
          if (!q) return true;
          const linkedCity = cities.find((c) => String(c.id) === String(h.city_id));
          const cityName = h.hospitalCity || (linkedCity ? linkedCity.name : "");
          return (
            (h.hospitalName || "").toLowerCase().includes(q) ||
            (cityName || "").toLowerCase().includes(q) ||
            (h.hospitalAddress || "").toLowerCase().includes(q) ||
            String(h.hospitalPincode || "").toLowerCase().includes(q)
          );
        });
        return (
          <div className={styles.doctorsManagement}>
            <div className={styles.sectionTitle}>
              <h2>Hospital Section</h2>
            </div>
            <div className={styles.toolbar}>
              <div className={styles.toolbarLeft}>
                <input
                  type="text"
                  className={styles.toolbarSearch}
                  placeholder="Search by name / city / address / pincode"
                  value={hospitalQuery}
                  onChange={(e) => setHospitalQuery(e.target.value)}
                />
              </div>
              <div className={styles.toolbarRight}>
                <button className={styles.addHospitalBtn} onClick={() => setShowHospitalModal(true)}>
                  + Add New Hospital
                </button>
                <button className={styles.bulkUploadBtn} onClick={() => setShowHospitalBulkUpload(true)}>
                  Bulk Upload
                </button>
                <button
                  className={styles.exportIconBtn}
                  title="Export to Excel"
                  aria-label="Export to Excel"
                  onClick={() => handleExportHospitals(filteredHospitals)}
                >
                  <FaFileExcel size={20} />
                </button>
              </div>
            </div>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Hospital Name</th>
                    <th>City</th>
                    <th>Address</th>
                    <th>Pincode</th>
                    <th style={{ textAlign: "right" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredHospitals.map((hospital) => {
                    const city = cities.find((c) => String(c.id) === String(hospital.city_id));
                    return (
                      <tr key={hospital.id}>
                        <td>{hospital.id}</td>
                        <td>{hospital.hospitalName}</td>
                        <td>{hospital.hospitalCity || (city ? city.name : "-")}</td>
                        <td>{hospital.hospitalAddress || "-"}</td>
                        <td>{hospital.hospitalPincode || "-"}</td>
                        <td style={{ textAlign: "right" }}>
                          <button className={styles.editBtn} onClick={() => openEditHospital(hospital)} title="Edit" style={{ marginRight: 6 }}>✏️</button>
                          <button className={styles.editBtn} onClick={() => handleDeleteHospital(hospital)} title="Delete" style={{ color: "crimson" }}>🗑️</button>
                        </td>
                      </tr>
                    );
                  })}
                  {filteredHospitals.length === 0 && <tr><td colSpan={6} style={{ textAlign: "center", padding: 16 }}>No hospitals found.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        );
      }
      case "doctors":
        return (
          <div className={styles.doctorsManagement}>
            <div className={styles.sectionTitle}>
              <h2>Doctors Section</h2>
            </div>

            {/* Tabs */}
            <div className={styles.tabRow} style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <button
                className={`${styles.tabBtn} ${activeDocTab === "byLocation" ? styles.tabActive : ""}`}
                onClick={() => setActiveDocTab("byLocation")}
              >
                By Location
              </button>
              <button
                className={`${styles.tabBtn} ${activeDocTab === "all" ? styles.tabActive : ""}`}
                onClick={() => setActiveDocTab("all")}
              >
                All Doctors
              </button>
            </div>

            {/* TAB: By Location */}
            {activeDocTab === "byLocation" && (
              <div className={styles.toolbar}>
                <div className={styles.selectionContainer} style={{ margin: 0, flex: "1 1 auto", flexWrap: "wrap" }}>
                  <select
                    className={styles.selectionDropdown}
                    onChange={(e) => setSelectedCityForDoctor(e.target.value)}
                    value={SelectedCityForDoctor}
                  >
                    <option value="">City List</option>
                    {cities.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </select>

                  <select
                    className={styles.selectionDropdown}
                    onChange={(e) => setSelectedHospitalforDoctor(e.target.value)}
                    value={SelectedHospitalforDoctor}
                    disabled={!SelectedCityForDoctor}
                  >
                    <option value="">Hospital List</option>
                    {selectedCityhospitals.map((hospital) => (
                      <option key={hospital.id} value={hospital.id}>
                        {hospital.hospitalName}
                      </option>
                    ))}
                  </select>

                  <select className={styles.selectionDropdown}>
                    <option value="">Doctor List</option>
                    {SelectedHospitalDoctorsList.map((doctor) => (
                      <option key={doctor.id} value={doctor.id}>
                        {doctor.doctorName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.toolbarRight}>
                  <button className={styles.addDoctorBtn} onClick={() => setShowDoctorModal(true)}>
                    + Add New Doctor
                  </button>
                </div>
              </div>
            )}

            {/* TAB: All Doctors */}
            {activeDocTab === "all" && (
              <>
                {/* Filters row */}
                <div className={styles.toolbar}>
                  <div className={styles.selectionContainer} style={{ margin: 0, gap: 8, flexWrap: "wrap", flex: "1 1 auto" }}>
                    <select
                      className={styles.selectionDropdown}
                      value={SelectedCityForDoctor}
                      onChange={(e) => {
                        setSelectedCityForDoctor(e.target.value);
                        setSelectedHospitalforDoctor("");
                      }}
                    >
                      <option value="">Filter: All City</option>
                      {cities.map((city) => (
                        <option key={city.id} value={city.id}>
                          {city.name}
                        </option>
                      ))}
                    </select>

                    <select
                      className={styles.selectionDropdown}
                      value={SelectedHospitalforDoctor}
                      onChange={(e) => setSelectedHospitalforDoctor(e.target.value)}
                      disabled={!SelectedCityForDoctor}
                    >
                      <option value="">Filter: Hospital</option>
                      {hospitals
                        .filter((h) => !SelectedCityForDoctor || String(h.city_id) === String(SelectedCityForDoctor))
                        .map((hospital) => (
                          <option key={hospital.id} value={hospital.id}>
                            {hospital.hospitalName}
                          </option>
                        ))}
                    </select>

                    <input
                      type="text"
                      className={styles.cityDropdown}
                      placeholder="Search (name / mobile / email)"
                      value={allDocQuery}
                      onChange={(e) => setAllDocQuery(e.target.value)}
                      style={{ minWidth: 240 }}
                    />
                  </div>

                  <div className={styles.toolbarRight}>
                    <button className={styles.addDoctorBtn} onClick={() => setShowDoctorModal(true)}>
                      + Add New Doctor
                    </button>
                    <button className={styles.bulkUploadBtn} onClick={() => setShowDoctorBulkUpload(true)}>
                      Bulk Upload
                    </button>
                    <button
                      className={styles.exportIconBtn}
                      title="Export to Excel"
                      aria-label="Export to Excel"
                      onClick={handleExportDoctors}
                    >
                      <FaFileExcel size={20} />
                    </button>
                  </div>
                </div>

                {/* Results table */}
                <div className={styles.tableWrapper}>
                  {allDocLoading ? (
                    <div className={styles.loading}>Loading doctors…</div>
                  ) : allDocError ? (
                    <div className={styles.error}>{allDocError}</div>
                  ) : (
                    <table className={styles.table}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: "left" }}>Doctor</th>
                          <th style={{ textAlign: "left" }}>Hospital</th>
                          <th style={{ textAlign: "left" }}>City</th>
                          <th style={{ textAlign: "left" }}>Mobile</th>
                          <th style={{ textAlign: "left" }}>Email</th>
                          <th style={{ textAlign: "right" }}>Actions</th>
                          <th style={{ textAlign: "right" }}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          const hospitalById = new Map(hospitals.map((h) => [String(h.id), h]));
                          const cityById = new Map(cities.map((c) => [String(c.id), c]));

                          let list = allDoctors.map((d) => {
                            const h = hospitalById.get(String(d.hospital_id));
                            const c =
                              h && h.city_id != null
                                ? cityById.get(String(h.city_id))
                                : d.city_id != null
                                ? cityById.get(String(d.city_id))
                                : undefined;

                            return {
                              ...d,
                              _hospitalName: d.hospitalName || h?.hospitalName || "",
                              _cityName: d.cityName || c?.name || "",
                            };
                          });

                          if (SelectedCityForDoctor) {
                            list = list.filter((d) => {
                              const h = hospitalById.get(String(d.hospital_id));
                              const cityIdFromHospital = h ? String(h.city_id) : undefined;
                              const cityId = cityIdFromHospital || (d.city_id != null ? String(d.city_id) : undefined);
                              return cityId === String(SelectedCityForDoctor);
                            });
                          }

                          if (SelectedHospitalforDoctor) {
                            list = list.filter((d) => String(d.hospital_id) === String(SelectedHospitalforDoctor));
                          }

                          const q = allDocQuery.trim().toLowerCase();
                          if (q) {
                            list = list.filter(
                              (d) =>
                                (d.doctorName || "").toLowerCase().includes(q) ||
                                (d.mobile_number || "").toLowerCase().includes(q) ||
                                (d.email || "").toLowerCase().includes(q) ||
                                (d._hospitalName || "").toLowerCase().includes(q) ||
                                (d._cityName || "").toLowerCase().includes(q)
                            );
                          }

                          if (list.length === 0) {
                            return (
                              <tr>
                                <td colSpan={6} style={{ textAlign: "center", padding: "16px" }}>
                                  No doctors found.
                                </td>
                              </tr>
                            );
                          }

                          return list.map((d) => (
                            <tr key={d.id}>
                              <td>{d.doctorName || "-"}</td>
                              <td>{d._hospitalName || "-"}</td>
                              <td>{d._cityName || "-"}</td>
                              <td>{d.mobile_number || "-"}</td>
                              <td>{d.email || "-"}</td>
                              <td style={{ textAlign: "right" }}>
                                <button
                                  className={styles.editBtn}
                                  onClick={() => openEditDoctor(d)}
                                  title="Edit"
                                >
                                  ✏️
                                </button>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                <button
                                  className={styles.editBtn}
                                  onClick={() => handleDeleteDoctor(d)}
                                  title="Delete"
                                  style={{ color: "crimson" }}
                                >
                                  🗑️
                                </button>
                              </td>
                            </tr>
                          ));
                        })()}
                      </tbody>
                    </table>
                  )}
                </div>
              </>
            )}
          </div>
        );
      case "users":
        return <UserRegions />;
      case "tests":
        return <TestList />;
      case "pricing":
        return <PriceList />;
      case "performance":
        return <DoctorPerformanceDashboard />;
      case "mappings":
        return <RegionalMappings />;
      case "emailMappings":
        return <EmailMappings />;
      case "phlebotomists":
        return <Phlebotomists />;
      case "salesAccess":
        return (
          <div className={styles.doctorsManagement}>
            <div className={styles.sectionTitle}>
              <h2>Sales Access Configuration</h2>
            </div>
            <p style={{ color: "#555", marginBottom: 16 }}>
              Set the earliest date each sales person can view sales data from.
              Leave blank to allow full history.
            </p>
            {!salesAccessLoaded ? (
              <div>Loading...</div>
            ) : salesAccessUsers.length === 0 ? (
              <div style={{ color: "#888" }}>No active sales persons found.</div>
            ) : (
              <div className={styles.tableWrapper}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>Username</th>
                      <th style={{ textAlign: "left" }}>Name</th>
                      <th style={{ textAlign: "left" }}>Data Visible From</th>
                      <th style={{ textAlign: "left" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {salesAccessUsers.map((u) => (
                      <tr key={u.Username}>
                        <td>{u.Username}</td>
                        <td>{u.name || u.Username}</td>
                        <td>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <input
                              type="date"
                              value={salesAccessDates[u.Username] || ""}
                              onChange={(e) =>
                                setSalesAccessDates((prev) => ({
                                  ...prev,
                                  [u.Username]: e.target.value,
                                }))
                              }
                              style={{ padding: "4px 8px", borderRadius: 4, border: "1px solid #ccc" }}
                            />
                            {salesAccessDates[u.Username] && (
                              <button
                                className={styles.closeBtn}
                                style={{ padding: "2px 8px", fontSize: 12 }}
                                onClick={() =>
                                  setSalesAccessDates((prev) => ({ ...prev, [u.Username]: "" }))
                                }
                                title="Clear — allow all dates"
                              >
                                Clear
                              </button>
                            )}
                          </div>
                        </td>
                        <td>
                          <button
                            className={styles.submitBtn}
                            style={{ padding: "4px 14px", fontSize: 13 }}
                            onClick={() => handleSaveSalesAccessForUser(u.Username)}
                            disabled={!!salesAccessSaving[u.Username]}
                          >
                            {salesAccessSaving[u.Username] ? "Saving..." : "Save"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      case "emailAutomation":
        return (
          <section className={styles.emailAutomationPage}>
            <header className={styles.emailAutomationHeader}>
              <div>
                <h2>Report Email Automation</h2>
                <p>Daily report delivery schedule</p>
              </div>
              {emailAutomationLoaded && (
                <span className={`${styles.emailAutomationStatus} ${emailAutomationSettings.enabled ? styles.statusEnabled : styles.statusDisabled}`}>
                  {emailAutomationSettings.enabled ? "Enabled" : "Disabled"}
                </span>
              )}
            </header>
            {!emailAutomationLoaded ? (
              <div className={styles.emailAutomationLoading}>Loading settings...</div>
            ) : (
              <div className={styles.emailAutomationBody}>
                <div className={styles.emailAutomationSwitchRow}>
                  <div>
                    <h3>Automatic delivery</h3>
                    <p>{emailAutomationSettings.enabled ? "Scheduled delivery is on" : "Scheduled delivery is off"}</p>
                  </div>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={emailAutomationSettings.enabled}
                    aria-label="Enable automatic report emails"
                    className={`${styles.emailAutomationSwitch} ${emailAutomationSettings.enabled ? styles.switchOn : ""}`}
                    onClick={() => setEmailAutomationSettings((current) => ({
                      ...current,
                      enabled: !current.enabled,
                    }))}
                  >
                    <span />
                  </button>
                </div>
                {emailAutomationSettings.enabled && (
                  <>
                    <div className={styles.emailAutomationFields}>
                      <label className={styles.emailAutomationField}>
                        <span>Start date</span>
                        <input
                          type="date"
                          value={emailAutomationSettings.startDate}
                          onChange={(event) => setEmailAutomationSettings((current) => ({
                            ...current,
                            startDate: event.target.value,
                          }))}
                          required
                        />
                      </label>
                      <label className={styles.emailAutomationField}>
                        <span>Daily send time <small>IST</small></span>
                        <input
                          type="time"
                          value={emailAutomationSettings.sendTime}
                          onChange={(event) => setEmailAutomationSettings((current) => ({
                            ...current,
                            sendTime: event.target.value,
                          }))}
                          required
                        />
                      </label>
                    </div>
                  </>
                )}
                <footer className={styles.emailAutomationFooter}>
                  {emailAutomationSettings.enabled && (!emailAutomationSettings.startDate || !emailAutomationSettings.sendTime) && (
                    <span className={styles.emailAutomationHint}>Enter a start date and send time to continue.</span>
                  )}
                  <button
                    type="button"
                    className={styles.emailAutomationSave}
                    onClick={handleSaveEmailAutomationSettings}
                    disabled={emailAutomationSaving || (emailAutomationSettings.enabled && (!emailAutomationSettings.startDate || !emailAutomationSettings.sendTime))}
                  >
                    {emailAutomationSaving ? "Saving..." : "Save settings"}
                  </button>
                </footer>
              </div>
            )}
          </section>
        );
      case "passkey":
        return (
          <div className={styles.doctorsManagement}>
            <div className={styles.sectionTitle}>
              <h2>Security - Passkey Management</h2>
            </div>
            {isPasskeySupported() ? (
              <div className={styles.passkeyContainer}>
                <div className={styles.passkeyInfo}>
                  <h3>Enable Passkey (WebAuthn) Authentication</h3>
                  <p>
                    Passkey authentication allows you to log in using your device's biometric or PIN authentication
                    (fingerprint, Face ID, Windows Hello, etc.) without using a password.
                  </p>
                  <div className={styles.benefits}>
                    <h4>Benefits:</h4>
                    <ul>
                      <li>✓ More secure than passwords</li>
                      <li>✓ Faster login process</li>
                      <li>✓ No password to forget or share</li>
                      <li>✓ Protected against phishing attacks</li>
                    </ul>
                  </div>
                  {passkeyRegistered && (
                    <div className={styles.successMessage}>
                      <p>✓ Passkey has been successfully registered for your account.</p>
                    </div>
                  )}
                  <button
                    className={styles.passkeyRegisterBtn}
                    onClick={handlePasskeyRegister}
                    disabled={passkeyLoading}
                  >
                    {passkeyLoading ? "Registering..." : "Register Passkey"}
                  </button>
                  <button
                    className={styles.passkeyCheckBtn}
                    onClick={checkPasskeyStatus}
                    style={{ marginTop: '10px' }}
                  >
                    Check Passkey Status
                  </button>
                </div>
              </div>
            ) : (
              <div className={styles.unsupported}>
                <p>⚠️ Your browser does not support passkey authentication.</p>
                <p>Please use a modern browser: Chrome, Firefox, Safari, or Edge.</p>
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.managementContainer}>
      <ToastContainer position="bottom-right" autoClose={5000} />
      <div className={styles.sidebar}>
        {accessibleTabs.map(tabKey => (
            <button
                key={tabKey}
                className={`${styles.sidebarBtn} ${activeTab === tabKey ? styles.active : ""}`}
                onClick={() => setActiveTab(tabKey)}
            >
                {allTabs[tabKey]}
            </button>
        ))}
      </div>
      <div className={styles.content} key={activeTab}>
        {renderContent()}
      </div>

      {/* Modal: Edit City */}
      {showEditCityModal && (
        <div className={styles.hmBackdrop} onClick={() => setShowEditCityModal(false)}>
          <div className={styles.hmCard} onClick={(e) => e.stopPropagation()}>
            <div className={styles.hmHeader}>
              <h5 className={styles.hmTitle}>Edit City</h5>
              <button type="button" className={styles.hmClose} onClick={() => setShowEditCityModal(false)}>
                &times;
              </button>
            </div>
            <div className={styles.hmBody}>
              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>
                  City Name <span className={styles.hmReq}>*</span>
                </label>
                <input
                  type="text"
                  value={editCityName}
                  onChange={(e) => setEditCityName(e.target.value)}
                  className={styles.hmInput}
                  placeholder="Enter city name"
                />
              </div>
            </div>
            <div className={styles.hmFooter}>
              <button className={styles.hmBtnSecondary} onClick={() => setShowEditCityModal(false)}>
                Cancel
              </button>
              <button className={styles.hmBtnPrimary} onClick={handleEditCity} disabled={loading}>
                {loading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Edit Hospital */}
      {showEditHospitalModal && (
        <div className={styles.hmBackdrop} onClick={closeEditHospitalModal}>
          <div className={styles.hmCard} onClick={(e) => e.stopPropagation()}>
            <div className={styles.hmHeader}>
              <h5 className={styles.hmTitle}>Edit Hospital</h5>
              <button type="button" className={styles.hmClose} onClick={closeEditHospitalModal}>
                &times;
              </button>
            </div>

            <div className={styles.hmBody}>
              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>
                  City <span className={styles.hmReq}>*</span>
                </label>
                <select
                  className={styles.hmInput}
                  value={editHospitalCity}
                  onChange={(e) => setEditHospitalCity(e.target.value)}
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city.id} value={city.id}>{city.name}</option>
                  ))}
                </select>
              </div>

              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>
                  Hospital Name <span className={styles.hmReq}>*</span>
                </label>
                <input
                  type="text"
                  value={editHospitalName}
                  onChange={(e) => setEditHospitalName(e.target.value)}
                  className={styles.hmInput}
                  placeholder="Enter hospital name"
                />
              </div>

              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>Address</label>
                <input
                  type="text"
                  value={editHospitalAddress}
                  onChange={(e) => setEditHospitalAddress(e.target.value)}
                  className={styles.hmInput}
                  placeholder="Enter hospital address"
                  maxLength="500"
                />
              </div>

              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>Pincode</label>
                <input
                  type="text"
                  value={editHospitalPincode}
                  onChange={(e) => setEditHospitalPincode(e.target.value)}
                  className={styles.hmInput}
                  placeholder="e.g. 682041"
                  maxLength="10"
                />
              </div>
            </div>

            <div className={styles.hmFooter}>
              <button className={styles.hmBtnSecondary} onClick={closeEditHospitalModal}>
                Cancel
              </button>
              <button className={styles.hmBtnPrimary} onClick={handleEditHospital} disabled={loading}>
                {loading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Add City */}
      {showCityModal && (
        <div className={styles.hmBackdrop} onClick={() => setShowModal(false)}>
          <div className={styles.hmCard} onClick={(e) => e.stopPropagation()}>
            <div className={styles.hmHeader}>
              <h5 className={styles.hmTitle}>Add New City</h5>
              <button type="button" className={styles.hmClose} onClick={() => setShowModal(false)}>
                &times;
              </button>
            </div>
            <div className={styles.hmBody}>
              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>
                  City Name <span className={styles.hmReq}>*</span>
                </label>
                <input
                  type="text"
                  value={newCity}
                  onChange={(e) => setNewCity(e.target.value)}
                  className={styles.hmInput}
                  placeholder="Enter city name"
                />
              </div>
            </div>
            <div className={styles.hmFooter}>
              <button className={styles.hmBtnSecondary} onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button className={styles.hmBtnPrimary} onClick={handleAddCity} disabled={loading}>
                {loading ? "Adding..." : "Add City"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Add Hospital */}
      {showHospitalModal && (
        <div className={styles.hmBackdrop} onClick={closeHospitalModal}>
          <div className={styles.hmCard} onClick={(e) => e.stopPropagation()}>
            <div className={styles.hmHeader}>
              <h5 className={styles.hmTitle}>Add New Hospital</h5>
              <button type="button" className={styles.hmClose} onClick={closeHospitalModal}>
                &times;
              </button>
            </div>

            <div className={styles.hmBody}>
              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>
                  City <span className={styles.hmReq}>*</span>
                </label>
                <select
                  className={styles.hmInput}
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>
                  Hospital Name <span className={styles.hmReq}>*</span>
                </label>
                <input
                  type="text"
                  value={newHospital}
                  onChange={(e) => setNewHospital(e.target.value)}
                  className={styles.hmInput}
                  placeholder="Enter hospital name"
                />
              </div>

              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>Address</label>
                <input
                  type="text"
                  value={newHospitalAddress}
                  onChange={(e) => setNewHospitalAddress(e.target.value)}
                  className={styles.hmInput}
                  placeholder="Enter hospital address"
                  maxLength="500"
                />
              </div>

              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>Pincode</label>
                <input
                  type="text"
                  value={newHospitalPincode}
                  onChange={(e) => setNewHospitalPincode(e.target.value)}
                  className={styles.hmInput}
                  placeholder="e.g. 682041"
                  maxLength="10"
                />
              </div>
            </div>

            <div className={styles.hmFooter}>
              <button className={styles.hmBtnSecondary} onClick={closeHospitalModal}>
                Cancel
              </button>
              <button
                className={styles.hmBtnPrimary}
                onClick={handleAddHospital}
                disabled={loading}
              >
                {loading ? "Adding..." : "Add Hospital"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Add Doctor */}
      {showDoctorModal &&
        (() => {
          const selectedCityObj = cities.find(
            (city) => city.id === parseInt(SelectedCityForDoctor || "", 10)
          );
          const selectedHospitalObj = hospitals.find(
            (hospital) => hospital.id === parseInt(SelectedHospitalforDoctor || "", 10)
          );

          return (
            <div className={styles.hmBackdrop} onClick={() => setShowDoctorModal(false)}>
              <div className={styles.hmCard} onClick={(e) => e.stopPropagation()}>
                <div className={styles.hmHeader}>
                  <h5 className={styles.hmTitle}>Add New Doctor (Primary Physician)</h5>
                  <button
                    type="button"
                    className={styles.hmClose}
                    onClick={() => setShowDoctorModal(false)}
                  >
                    &times;
                  </button>
                </div>

                <div className={styles.hmBody}>
                  <div className={styles.hmRow}>
                    <div className={styles.hmGroup}>
                      <label className={styles.hmLabel}>Selected City</label>
                      <div className={styles.hmStatic}>
                        {selectedCityObj ? selectedCityObj.name : "No City Selected"}
                      </div>
                    </div>
                    <div className={styles.hmGroup}>
                      <label className={styles.hmLabel}>Selected Hospital</label>
                      <div className={styles.hmStatic}>
                        {selectedHospitalObj
                          ? selectedHospitalObj.hospitalName
                          : "No Hospital Selected"}
                      </div>
                    </div>
                  </div>

                  <div className={styles.hmGroup}>
                    <label className={styles.hmLabel}>
                      Doctor Name <span className={styles.hmReq}>*</span>
                    </label>
                    <input
                      type="text"
                      value={newDoctor}
                      onChange={(e) => setnewDoctor(e.target.value)}
                      className={styles.hmInput}
                      placeholder="Enter Doctor name"
                    />
                    <span className={styles.hmHelp}>Ex: Dr. Arun Sharma</span>
                  </div>

                  <div className={styles.hmRow}>
                    <div className={styles.hmGroup}>
                      <label className={styles.hmLabel}>Mobile Number</label>
                      <input
                        type="text"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        className={styles.hmInput}
                        placeholder="Enter Mobile Number"
                      />
                    </div>
                    <div className={styles.hmGroup}>
                      <label className={styles.hmLabel}>Email Id</label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={styles.hmInput}
                        placeholder="Enter Email id"
                      />
                    </div>
                  </div>

                  <div className={styles.hmGroup}>
                    <label className={styles.hmLabel}>Hospital</label>
                    <select
                      className={styles.hmInput}
                      value={editHospitalId}
                      onChange={(e) => setEditHospitalId(e.target.value)}
                    >
                      <option value="">Select Hospital</option>
                      {hospitals.map((h) => (
                        <option key={h.id} value={h.id}>
                          {h.hospitalName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className={styles.hmFooter}>
                  <button
                    className={styles.hmBtnSecondary}
                    onClick={() => setShowDoctorModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className={styles.hmBtnPrimary}
                    onClick={handleAddDoctor}
                    disabled={loading}
                  >
                    {loading ? "Adding..." : "Add Doctor"}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

      {/* Modal: Bulk Upload Doctors */}
      {showDoctorBulkUpload && (
        <BulkUploadModal
          type="doctors"
          hospitals={hospitals}
          cities={cities}
          existingDoctors={allDoctors}
          onImport={handleDoctorsBulkImport}
          onClose={() => setShowDoctorBulkUpload(false)}
        />
      )}

      {/* Modal: Bulk Upload Hospitals */}
      {showHospitalBulkUpload && (
        <BulkUploadModal
          type="hospitals"
          cities={cities}
          existingHospitals={hospitals}
          onImport={handleHospitalsBulkImport}
          onClose={() => setShowHospitalBulkUpload(false)}
        />
      )}

      {/* Modal: Edit Doctor */}
      {editOpen && (
        <div className={styles.hmBackdrop} onClick={() => setEditOpen(false)}>
          <div className={styles.hmCard} onClick={(e) => e.stopPropagation()}>
            <div className={styles.hmHeader}>
              <h5 className={styles.hmTitle}>Edit Doctor</h5>
              <button type="button" className={styles.hmClose} onClick={() => setEditOpen(false)}>
                &times;
              </button>
            </div>

            <div className={styles.hmBody}>
              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>
                  Doctor Name <span className={styles.hmReq}>*</span>
                </label>
                <input
                  type="text"
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                  className={styles.hmInput}
                  placeholder="Enter Doctor name"
                />
              </div>

              <div className={styles.hmRow}>
                <div className={styles.hmGroup}>
                  <label className={styles.hmLabel}>Mobile Number</label>
                  <input
                    type="text"
                    value={editMobile}
                    onChange={(e) => setEditMobile(e.target.value)}
                    className={styles.hmInput}
                    placeholder="Enter Mobile Number"
                  />
                </div>
                <div className={styles.hmGroup}>
                  <label className={styles.hmLabel}>Email Id</label>
                  <input
                    type="email"
                    value={editEmail}
                    onChange={(e) => setEditEmail(e.target.value)}
                    className={styles.hmInput}
                    placeholder="Enter Email id"
                  />
                </div>
              </div>

              <div className={styles.hmGroup}>
                <label className={styles.hmLabel}>Hospital</label>
                <select
                  className={styles.hmInput}
                  value={editHospitalId}
                  onChange={(e) => setEditHospitalId(e.target.value)}
                >
                  <option value="">Select Hospital</option>
                  {hospitals.map((h) => (
                    <option key={h.id} value={h.id}>
                      {h.hospitalName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className={styles.hmFooter}>
              <button className={styles.hmBtnSecondary} onClick={() => setEditOpen(false)}>
                Cancel
              </button>
              <button className={styles.hmBtnPrimary} onClick={saveDoctorEdit}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Management;
